var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductT1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.62 18.9393L37.62 19.0155C37.5697 20.0904 36.4605 21.0792 34.915 21.0792L5.08644 21.0792C3.50618 21.0792 2.37974 20.0431 2.37974 18.9393C2.37974 17.8356 3.50618 16.7994 5.08644 16.7994L34.9133 16.7994C36.4951 16.7994 37.62 17.8354 37.62 18.9393Z",
    fill: "url(#paint0_linear_7153_13988)",
    stroke: "#187C85",
    strokeWidth: 0.880565
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79872 1.31948L2.87486 1.31948C3.9498 1.36975 4.93863 2.47897 4.93863 4.02441L4.93862 33.853C4.93862 35.4333 3.90249 36.5597 2.79871 36.5597C1.69494 36.5597 0.658818 35.4333 0.658819 33.853L0.658821 4.0262C0.658821 2.44432 1.6948 1.31948 2.79872 1.31948Z",
    fill: "url(#paint1_linear_7153_13988)",
    stroke: "#187C85",
    strokeWidth: 0.880565
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2011 1.31948L37.2772 1.31948C38.3521 1.36975 39.341 2.47897 39.341 4.02441L39.341 33.853C39.341 35.4333 38.3048 36.5597 37.2011 36.5597C36.0973 36.5597 35.0612 35.4333 35.0612 33.853L35.0612 4.0262C35.0612 2.44432 36.0971 1.31948 37.2011 1.31948Z",
    fill: "url(#paint2_linear_7153_13988)",
    stroke: "#187C85",
    strokeWidth: 0.880565
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7153_13988",
    x1: 46.2834,
    y1: 30.3951,
    x2: 6.7071,
    y2: 16.7363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7153_13988",
    x1: 14.2545,
    y1: -7.34395,
    x2: 0.595648,
    y2: 32.2323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7153_13988",
    x1: 48.6569,
    y1: -7.34395,
    x2: 34.998,
    y2: 32.2323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductT1);
export default __webpack_public_path__ + "static/media/product-t1.958304a68665aea29f56bb4075c32a62.svg";
export { ForwardRef as ReactComponent };